import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 2a5 5 0 1 1 -5 5l.005 -.217a5 5 0 0 1 4.995 -4.783z","key":"svg-0"}],["path",{"d":"M14 14a5 5 0 0 1 5 5v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1a5 5 0 0 1 5 -5h4z","key":"svg-1"}]]

/**
 * IconUserFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItdXNlciIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgMmE1IDUgMCAxIDEgLTUgNWwuMDA1IC0uMjE3YTUgNSAwIDAgMSA0Ljk5NSAtNC43ODN6IiAvPgogIDxwYXRoIGQ9Ik0xNCAxNGE1IDUgMCAwIDEgNSA1djFhMiAyIDAgMCAxIC0yIDJoLTEwYTIgMiAwIDAgMSAtMiAtMnYtMWE1IDUgMCAwIDEgNSAtNWg0eiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/user-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconUserFilled = createReactComponent('filled', 'user-filled', 'UserFilled', __iconNode);

export default IconUserFilled;